import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TasksService } from 'src/app/modules/go/services/tasks.service';
import { StoreService } from 'src/app/services/store.service';
import { UserModel } from 'src/app/model/general.model';
import { userOptionLabel } from 'src/app/utils/user.utils';

@Component({
  selector: 'order-users-dialog',
  templateUrl: './task-assignees-dialog.component.html',
  styleUrls: []
})
export class TaskAssigneesDialogComponent {

  form: FormGroup = this.formBuilder.group({
    user: [this.data.currentUser?.id ?? '', [Validators.required]]
  })

  constructor(
    public dialogRef: MatDialogRef<TaskAssigneesDialogComponent>,
    private formBuilder: FormBuilder,
    private store: StoreService,
    public tasksService: TasksService,
    @Inject(MAT_DIALOG_DATA) public data: {currentUser: UserModel, taskId: number, users: UserModel[]}
  ) {
  }

  onSubmit(): void {
    if (this.form.valid) {
      this.store.showLoader();
      this.tasksService.assignTasksToUser([this.data.taskId], this.form.value.user === "-" ? null : this.form.value.user).subscribe(() => {
        this.dialogRef.close();
        this.store.showSuccessMsg('TASKS.SET_ASSIGNEE_SUCCESS');
        this.tasksService.refreshTasks();
      })
    }
  }

  getUserLabel(user: UserModel): string {
    return userOptionLabel(user);
  }

}
